import React from 'react';
import { CircularProgress } from '@mui/material';

/** MUI Button `startIcon` while an async action is in flight. */
export function buttonStartIcon(loading, Icon, iconProps) {
  if (loading) return <CircularProgress size={18} color="inherit" />;
  return Icon ? <Icon {...(iconProps || {})} /> : null;
}

/** IconButton child while a keyed async action is pending. */
export function iconButtonContent(pending, node) {
  if (pending) return <CircularProgress size={16} color="inherit" />;
  return node;
}
